import axios from "axios";
import ApiService from "@/services/ApiService.js";

export const state = {
  estados:[],
};
export const mutations = {
  FILL_ESTADOS_CIVILES({ context }, estados) {
    let lista_estados = [];
    if (estados) {
      Object.entries(estados).forEach(([key, val]) => lista_estados.push(val));
      return (state.estados = lista_estados);
    }
  }
};
export const actions = {
    GET_ESTADOS_CIVILES({ commit }, data) {
        return new Promise((resolve, reject) => {
          commit("SET_LOADING", true);
          ApiService.get(data)
            .then(response => {
              commit("SET_LOADING", false);
              commit("FILL_ESTADOS_CIVILES", response.data.data.edo_civiles);
              resolve(response);
            })
            .catch(error => {
              commit("SET_LOADING", false);
              reject(error);
            });
        });
      },
};

export const getters = {
  listEdoCiviles: state => state.estados,
};
